import { render, staticRenderFns } from "./ChartPetugasOmbro.vue?vue&type=template&id=37083255&"
import script from "./ChartPetugasOmbro.vue?vue&type=script&lang=js&"
export * from "./ChartPetugasOmbro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports